import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Action, Store } from '@ngrx/store';
import { maskConfig, moneyMaskPrefixedWithoutDecimal } from '../../masks';

export interface ConfirmationDialogProps {
  title?: string;
  message: string;
  icon?: IconProp;
  otherInfo?: {
    header: string;
    note: string;
    data?: any;
    caption?: string;
  };
  constructionCostInfo: {
    error: boolean;
    header: string;
    materialsCost?: number;
    laborAndOtherCost?: number;
  };
  cancelBtnText?: string;
  continueBtnText?: string;
  continueBtnAction?: Action;
  hideCancelButton?: boolean;
  showIcon?: boolean;
  showCloseIcon?: boolean;
}

@Component({
  selector: 'confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ConfirmationDialogComponent {
  maskConfig = maskConfig;
  moneyMask = moneyMaskPrefixedWithoutDecimal;
  constructor(
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogProps,
    private store: Store
  ) {}

  closeDialog(value?: boolean, materialsCost?: number, laborAndOtherCost?: number) {
    this.dialogRef.close({
      data: value,
      constructionCost:
        materialsCost && laborAndOtherCost
          ? { data: true, materialsCost: materialsCost, laborAndOtherCost: laborAndOtherCost }
          : { data: false },
    });
  }

  onContinue(materialsCost?: number, laborAndOtherCost?: number) {
    const action = this.data.continueBtnAction;

    if (action) this.store.dispatch(action);
    if (materialsCost && laborAndOtherCost)
      this.closeDialog(true, materialsCost, laborAndOtherCost);
    else this.closeDialog(true);
  }
}